import { IActivityDetail } from './iactivity-detail';
export interface IActivityDetailKind {
    detailKindIdentifier: string;
    display: string;
    definition: string;
    tenantId: number;
    language: string;
    activityDetail: IActivityDetail[];
}